import { isNullOrWhitespace, round, isString } from "./utils";



export function InToIn(Inches: string | number): string {

    if (isString(Inches)) {
        let ftdbl = InToFtDbl(Inches)
        return FtToIn(ftdbl);
    }

    let inch = Number(Inches);

    if (!isNaN(Inches)) {
        inch = inch / 12;
        return FtToIn(inch);
    }
    return "";

}

export function InToFtDbl(Inches: string): number {
    return InToInDbl(Inches) / 12;
}

export function InToInDbl(Inches: string): number {
    //if (Inches == null) return 0;
    if (isNullOrWhitespace(Inches)) return 0;

    if (Inches.includes("'") || (Inches.includes("-") && Inches.includes("/") === false) || (Inches.includes(" ") && Inches.includes("/") === false)) {
        return FtToInDbl(Inches);
    }
    else {
        //return (" " + Inches).FtToInDbl();
        let s = ' ' + Inches.toString();
        return FtToInDbl(s);
    }
}

export function FtToInDbl(ftIn: string): number {

    if (ftIn.includes('"') && !ftIn.includes("'") && !ftIn.includes(" ")) {
        ftIn = "0' " + ftIn;
    }
    let CurC = "", Ft = "", Inch = "", Fr = "", Fr2 = "";
    let Fraction = false, Dec = false, DecIn = false, Feet = false;
    let CurNum = 1;


    for (var cl = 1; cl <= ftIn.length; cl++) {

        CurC = ftIn.substring(cl - 1, cl);
        var exit = false;

        switch (CurNum) {
            case 1:
                //get value for feet
                switch (CurC) {
                    case "'":
                    case "-":
                    case "*":
                        Feet = true;
                        CurNum = 2;
                        break;
                    case "\"":
                        //return double.Parse(Ft);
                        return parseFloat(Ft);
                    case ".":
                        Ft += CurC;
                        Dec = true;
                        break;
                    case "/":
                        Fr = Ft;
                        Ft = "";
                        Fraction = true;
                        break;
                    case " ":
                        if (Dec) CurNum = 3; else CurNum = 2;
                        break;
                    case "1":
                    case "2":
                    case "3":
                    case "4":
                    case "5":
                    case "6":
                    case "7":
                    case "8":
                    case "9":
                    case "0":
                        if (Fraction) Fr2 += CurC; else Ft += CurC;
                        break;
                    case "\\":
                        break;
                    default:
                        exit = true;
                        break;
                }
                break;
            case 2:
                //get value for inches
                switch (CurC) {
                    case "\"":
                        exit = true;
                        break;
                    case ".":
                        Inch += CurC;
                        DecIn = true;
                        break;
                    case "/":
                        Fr = Inch;
                        if (Feet) Inch = ""; else { Inch = Ft; Ft = ""; }
                        Fraction = true;
                        break;
                    case " ":
                    //string t1 = FtIn.Substring(cl - 2);
                    //if (t1[0].ToString() != "'") if (DecIn) exit = true; else CurNum = 3;
                    //break;
                    case "-":
                    case "*":
                        let t = ftIn.substring(cl - 2);
                        if (t[0] != "'") {
                            if (DecIn) {
                                exit = true;
                            }
                            else { CurNum = 3; }
                        }
                        break;
                    case "1":
                    case "2":
                    case "3":
                    case "4":
                    case "5":
                    case "6":
                    case "7":
                    case "8":
                    case "9":
                    case "0":
                        if (Fraction) Fr2 += CurC; else Inch += CurC;
                        break;
                    case "\\":
                        break;
                    default:
                        exit = true;
                        break;
                }
                break;
            case 3:
                //get the value for fractional inches

                switch (CurC) {
                    case "\"":
                        exit = true;
                        break;
                    case "/":
                        Fraction = true;
                        break;
                    case " ":
                        if (DecIn) exit = true; else CurNum = 3;
                        break;
                    case "1":
                    case "2":
                    case "3":
                    case "4":
                    case "5":
                    case "6":
                    case "7":
                    case "8":
                    case "9":
                    case "0":
                        if (Fraction) Fr2 += CurC; else Fr += CurC;
                        break;
                    case "\\":
                        break;
                    default:
                        exit = true;
                        break;
                }
                break;
        }
        if (exit) break;
    } // end of for loop


    if (Fr === "") Fr = "0";
    if (Fr2 === "") Fr2 = "0";
    // Fr = (Fr.ToDouble() / Fr2.ToDouble()).ToString();
    Fr = (parseFloat(Fr) / parseFloat(Fr2)).toString();


    if (Fr === "NaN" || Fr === "∞") { Fr = "0"; }

    //if (isNaN(Fr)) {
    //   Fr = "0";
    // }

    if (Ft === "") Ft = "0";
    if (Inch === "") Inch = "0";
    if (Fr === "") Fr = "0";
    //return (Ft.ToDouble() * 12) + (Inch.ToDouble() + Fr.ToDouble());
    let r = (+Ft * 12) + +Inch + +Fr;
    return r;//(+Ft * 12) + +Inch + +Fr;
    //return (parseFloat(Ft) * 12) + (parseFloat(Inch) + parseFloat(Fr));
}

export function FtToIn(Num: number): string {

    let L = parseInt(round((Num * 12) * 16, 0).toString());
    let Inches = parseInt(Math.floor(L / 16).toString());
    let Fraction = L - (Inches * 16);
    let Lenlbl = "";
    switch (Fraction) {
        case 0:
            Lenlbl = Inches + "\"";
            break;
        case 1:
        case 3:
        case 5:
        case 7:
        case 9:
        case 11:
        case 13:
        case 15:
            Lenlbl = Inches + "-" + Fraction + "/16\"";
            break;
        case 2:
        case 6:
        case 10:
        case 14:
            Lenlbl = Inches + "-" + (Fraction / 2) + "/8\"";
            break;
        case 4:
        case 12:
            Lenlbl = Inches + "-" + (Fraction / 4) + "/4\"";
            break;
        case 8:
            Lenlbl = Inches + "-" + (Fraction / 8) + "/2\"";
            break;
    }
    if (Lenlbl.startsWith("0-")) {
        //Lenlbl = Lenlbl.Remove(0, 2);
        Lenlbl = Lenlbl.substr(2);
    }
    return Lenlbl;
}

export function FtToFt(Num: number) {
    let t1: string[] = [], t2: string[] = [];
    let t3: number;
    let Fraction: string;
    t1 = Num.toString().split('.');
    if (t1.length === 1) return Num.toString().concat("'");
    t2 = String((parseFloat("." + String(t1[1])) * 12)).split('.');
    if (t2.length < 2 || parseFloat(".".concat(t2[1])) < .0625) //no fraction
    {
        if (parseFloat(t2[0]) === 0) {
            return t2[0].concat("\"");
        }
        else {
            return t1[0].concat("' ").concat(t2[0]).concat("\"");
        }
    }
    let a = round((+("." + t2[1])) * 8, 0);
    t3 = parseInt(round((+("." + t2[1])) * 8, 0).toString());
    switch (t3) {
        case 1:
            Fraction = "1/8";
            break;
        case 2:
            Fraction = "1/4";
            break;
        case 3:
            Fraction = "3/8";
            break;
        case 4:
            Fraction = "1/2";
            break;
        case 5:
            Fraction = "5/8";
            break;
        case 6:
            Fraction = "3/4";
            break;
        case 7:
            Fraction = "7/8";
            break;
        case 8:
            Fraction = "";
            t2[0] = (parseInt(t2[0]) + 1).toString();
            break;
        default:
            Fraction = "";
            break;
    }
    if (t1[0] === "" || t1[0] === "") {
        //no feet
        if (t2[0] === "" || t2[0] === "") return Fraction + "\""; else return t2[0] + "-" + Fraction + "\"";
    }
    else {
        if (t2[0] === "" || t2[0] === "") {
            return t1[0] + "' " + Fraction + "\"";
        }
        else {
            if (t2[0] === "12") {
                return (parseInt(t1[0]) + 1).toString().concat("'");
            }
            if (Fraction == "") {
                return t1[0] + "' " + t2[0] + "\"";
            } else {
                return t1[0] + "' " + t2[0] + "-" + Fraction + "\"";
            }
        }

    }
}

export function FtToFtDbl(Ft: string) { return FtToInDbl(Ft) / 12; }